import NonAttendeeApplicationStatus from "./NonAttendeeApplicationStatus";

enum TicketStatus {
  TICKET_TRANSFER_ACCEPTANCE_PENDING = "TICKET_TRANSFER_ACCEPTANCE_PENDING",
  TICKET_TRANSFER_APPROVAL_PENDING = "TICKET_TRANSFER_APPROVAL_PENDING",
  APPLICATION_FLOW_APPROVAL_PENDING = "APPLICATION_FLOW_APPROVAL_PENDING",
  APPLICATION_FLOW_REJECTED = "APPLICATION_FLOW_REJECTED",
  APPLICATION_FLOW_PAYMENT_PENDING = "APPLICATION_FLOW_PAYMENT_PENDING",
  PAYMENT_FLOW_PAYMENT_PENDING = "PAYMENT_FLOW_PAYMENT_PENDING",
  PAYMENT_FLOW_APPROVAL_PENDING = "PAYMENT_FLOW_APPROVAL_PENDING",
  PAYMENT_RECEIPT_PENDING = "PAYMENT_RECEIPT_PENDING",
  PAYMENT_FLOW_REJECTED = "PAYMENT_FLOW_REJECTED",
  CHARGE_PAYMENT = "CHARGE_PAYMENT",
  REFUND_PAYMENT = "REFUND_PAYMENT",
  COMPLETED = "COMPLETED",
  TICKET_ACCEPTANCE_PENDING = "TICKET_ACCEPTANCE_PENDING",
  TICKET_ACCEPTANCE_APPROVAL_PENDING = "TICKET_ACCEPTANCE_APPROVAL_PENDING",
  FREEZED = "FREEZED",
  TRANSFERRED = "TRANSFERRED"
}

export function getIsResumeRegistrationApplicable(status: TicketStatus) {
  return [TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING, TicketStatus.PAYMENT_FLOW_PAYMENT_PENDING].includes(status);
}

export function CanAssignTicketToSelf(status: TicketStatus) {
  return ![
    TicketStatus.PAYMENT_FLOW_PAYMENT_PENDING,
    TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING,
    TicketStatus.PAYMENT_FLOW_APPROVAL_PENDING,
    TicketStatus.APPLICATION_FLOW_APPROVAL_PENDING
  ].includes(status);
}

export const PaymentReceiptPendingStatuses = [
  TicketStatus.PAYMENT_RECEIPT_PENDING,
  NonAttendeeApplicationStatus.BULK_TICKET_PAYMENT_RECEIPT_PENDING
];

export default TicketStatus;
